import React, { createContext, useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { properties } from "../utils/Properties_es";
import { setAuthData } from "../utils/LocalStorageManager";
import jwt_decode from "jwt-decode";
import { refreshTokenService } from "../services/security/refreshTokenService";
//define context
const AppContext = createContext();
const { Provider } = AppContext;

const AppProvider = ({ children, authData }) => {
  const [authInfo, setAuthInfo] = useState(authData);
  const [isLoading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [clientProfile, setProfileData] = useState({});
  const [modalData, setModalData] = useState({
    modalOpen: false,
    modalType: null,
    modalObject: null,
  });

  const [authenticate, setAuthenticate] = useState(() => {
    if (!authData) {
      return false;
    }
    const decodeToken = jwt_decode(authData?.accessToken);
    const expiresAt = decodeToken?.exp;
    let valid = new Date().getTime() / 1000 < expiresAt;
    if (valid) {
      return true;
    }
    return false;
  });
  const navigate = useNavigate();

  const loginProvider = async (loginData) => {
    try {
      //save login data in storage
      const authData = await setAuthData("authAdminInfo", loginData);
      if (!authData) {
        setAuthenticate(false);
        return;
      }

      const decodeToken = jwt_decode(authData?.accessToken);

      const expiresAt = decodeToken?.exp;
      let valid = new Date().getTime() / 1000 < expiresAt;
      if (valid) {
        setAuthenticate(valid);
        setAuthInfo(authData);
        navigate("/board/home", { replace: true });
        return;
      }
    } catch (error) {

      throw new Error(properties.com_parval_label_login_general_error);

    }
    setAuthenticate(false);
  };

  const logoutProvider = async (e) => {
    //e.preventDefault();
    await setAuthData("authAdminInfo", null);
    setAuthenticate(false);
    navigate("/", { replace: true });
  };

  // Refresca el token usando el refreshToken almacenado en authInfo
  const refreshAuthToken = async () => {
    if (!authInfo?.refreshToken) return;
    try {
      const newTokens = await refreshTokenService(authInfo.refreshToken);
      if (newTokens?.accessToken && newTokens?.refreshToken) {
        const updatedAuth = { ...authInfo, ...newTokens };
        setAuthInfo(updatedAuth);
        await setAuthData("authAdminInfo", updatedAuth);
        setAuthenticate(true);
      } else {
        logoutProvider();
      }
    } catch (error) {
      logoutProvider();
    }
  };

  // Refrescar token automáticamente cada 10 minutos
  useEffect(() => {
    if (!authenticate || !authInfo?.accessToken || !authInfo?.refreshToken) return;
    const interval = setInterval(() => {
      refreshAuthToken();
    }, 10 * 60 * 1000); // 10 minutos
    return () => clearInterval(interval);
  }, [authInfo, authenticate]);

  //Recordar descomentar
  useEffect(() => {
    let time = 300000;
    let timeOutTimer = setTimeout(logoutProvider, time);
    const checkInactivity = () => {
      window.onclick = () => checkInactivity();
      window.onkeypress = () => checkInactivity();
      window.addEventListener("mousemove", checkInactivity);
      clearTimeout(timeOutTimer);
      timeOutTimer = setTimeout(logoutProvider, time);
    };
    checkInactivity();
  }, []);

  const resetErrorMsg = () => {
    setErrorMsg(null);
  };

  const resetSuccessMsg = () => {
    setSuccessMsg(null);
  };

  const resetAllMsg = () => {
    setErrorMsg(null);
    setSuccessMsg(null);
  };

  useEffect(() => {
    console.log(authenticate);
  }, [authenticate]);

  const values = useMemo(
    () => ({
      authInfo,
      authenticate,
      isLoading,
      errorMsg,
      successMsg,
      modalData,
      clientProfile,
      loginProvider,
      logoutProvider,
      setLoading,
      resetErrorMsg,
      setErrorMsg,
      resetSuccessMsg,
      setSuccessMsg,
      resetAllMsg,
      setModalData,
      setProfileData,
      refreshAuthToken,
    }),
    // eslint-disable-next-line
    [
      authInfo,
      authenticate,
      isLoading,
      errorMsg,
      successMsg,
      modalData,
      clientProfile,
    ]
  );

  return <Provider value={values}>{children}</Provider>;
};

export { AppContext, AppProvider };
